import { transaction as O, typedData as m, stark as f, RPC as x, num as y, hash as S, CallData as _, CairoCustomEnum as M, shortString as E, Account as I, ec as k, selector as B, merkle as j, byteArray as K, encode as F, Signer as N } from "starknet";
const P = "https://cloud.argent-api.com/v1";
class C extends Error {
  constructor(t, e) {
    super(t), this.cause = e, Error.captureStackTrace(this, this.constructor);
  }
}
class V {
  constructor(t, e, o = P) {
    this.pubkey = t, this.accountSessionSignature = e, this.argentSessionServiceBaseUrl = o;
  }
  async signTxAndSession(t, e, o, n, r) {
    const a = O.getExecuteCalldata(
      t,
      e.cairoVersion
    ), i = m.getMessageHash(
      o,
      e.walletAddress
    ), c = f.formatSignature(
      this.accountSessionSignature
    ), l = {
      session: {
        sessionHash: i,
        sessionAuthorisation: c,
        cacheAuthorisation: r,
        sessionSignature: {
          type: "StarknetKey",
          signer: {
            publicKey: this.pubkey,
            r: n[0].toString(),
            s: n[1].toString()
          }
        }
      }
    };
    if (Object.values(x.ETransactionVersion2).includes(
      e.version
    )) {
      const d = e;
      l.transaction = {
        contractAddress: d.walletAddress,
        calldata: a,
        maxFee: d.maxFee.toString(),
        nonce: d.nonce.toString(),
        version: y.toBigInt(d.version).toString(10),
        chainId: y.toBigInt(d.chainId).toString(10)
      };
    } else if (Object.values(x.ETransactionVersion3).includes(
      e.version
    )) {
      const d = e;
      l.transaction = {
        sender_address: d.walletAddress,
        calldata: a,
        nonce: d.nonce.toString(),
        version: y.toBigInt(d.version).toString(10),
        chainId: y.toBigInt(d.chainId).toString(10),
        resource_bounds: {
          l1_gas: {
            max_amount: d.resourceBounds.l1_gas.max_amount.toString(),
            max_price_per_unit: d.resourceBounds.l1_gas.max_price_per_unit.toString()
          },
          l2_gas: {
            max_amount: d.resourceBounds.l1_gas.max_amount.toString(),
            max_price_per_unit: d.resourceBounds.l1_gas.max_price_per_unit.toString()
          }
        },
        tip: d.tip.toString(),
        paymaster_data: d.paymasterData.map((T) => T.toString()),
        account_deployment_data: d.accountDeploymentData,
        nonce_data_availability_mode: d.nonceDataAvailabilityMode,
        fee_data_availability_mode: d.feeDataAvailabilityMode
      };
    } else
      throw Error("unsupported signTransaction version");
    const u = await fetch(
      `${this.argentSessionServiceBaseUrl}/cosigner/signSession`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(l)
      }
    );
    if (!u.ok) {
      const d = await u.json();
      throw new C("Sign session error", d.status);
    }
    return (await u.json()).signature;
  }
  async signSessionEFO(t, e, o, n, r, a) {
    const i = m.getMessageHash(
      A(t, a),
      e
    ), c = f.formatSignature(
      this.accountSessionSignature
    ), u = {
      session: {
        sessionHash: i,
        sessionAuthorisation: c,
        cacheAuthorisation: r,
        sessionSignature: {
          type: "StarknetKey",
          signer: {
            publicKey: this.pubkey,
            r: n[0].toString(),
            s: n[1].toString()
          }
        }
      },
      message: {
        type: "eip712",
        accountAddress: e,
        chain: "starknet",
        message: o
      }
    }, g = JSON.stringify(
      u,
      (b, v) => typeof v == "bigint" ? v.toString() : v
    ), d = await fetch(
      `${this.argentSessionServiceBaseUrl}/cosigner/signSessionEFO`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: g
      }
    );
    if (!d.ok) {
      const b = await d.json();
      throw new C("Sign session error", b.status);
    }
    return (await d.json()).signature;
  }
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
BigInt(0);
BigInt(1);
BigInt(2);
function W(s) {
  return s instanceof Uint8Array || s != null && typeof s == "object" && s.constructor.name === "Uint8Array";
}
const U = /* @__PURE__ */ Array.from({ length: 256 }, (s, t) => t.toString(16).padStart(2, "0"));
function L(s) {
  if (!W(s))
    throw new Error("Uint8Array expected");
  let t = "";
  for (let e = 0; e < s.length; e++)
    t += U[s[e]];
  return t;
}
const J = {
  StarknetDomain: [
    { name: "name", type: "shortstring" },
    { name: "version", type: "shortstring" },
    { name: "chainId", type: "shortstring" },
    { name: "revision", type: "shortstring" }
  ],
  OutsideExecution: [
    { name: "Caller", type: "ContractAddress" },
    { name: "Nonce", type: "felt" },
    { name: "Execute After", type: "u128" },
    { name: "Execute Before", type: "u128" },
    { name: "Calls", type: "Call*" }
  ],
  Call: [
    { name: "To", type: "ContractAddress" },
    { name: "Selector", type: "selector" },
    { name: "Calldata", type: "felt*" }
  ]
};
function G(s) {
  return {
    name: "Account.execute_from_outside",
    version: "1",
    chainId: s,
    revision: "1"
  };
}
function $(s) {
  return {
    to: s.contractAddress,
    selector: S.getSelectorFromName(s.entrypoint),
    calldata: s.calldata ?? []
  };
}
function ee(s, t, e) {
  return m.getMessageHash(
    w(s, e),
    t
  );
}
function w(s, t) {
  return {
    types: J,
    primaryType: "OutsideExecution",
    domain: G(t),
    message: {
      Caller: s.caller,
      Nonce: s.nonce,
      "Execute After": s.execute_after,
      "Execute Before": s.execute_before,
      Calls: s.calls.map((e) => ({
        To: e.to,
        Selector: e.selector,
        Calldata: e.calldata
      }))
    }
  };
}
async function te(s, t, e, o, n) {
  n = n ?? await o.getChainId();
  const r = w(
    s,
    n
  ), a = await e.signMessage(r, t);
  return {
    contractAddress: t,
    entrypoint: "execute_from_outside_v2",
    calldata: _.compile({ ...s, signature: a })
  };
}
var h = /* @__PURE__ */ ((s) => (s[s.Starknet = 0] = "Starknet", s[s.Secp256k1 = 1] = "Secp256k1", s[s.Secp256r1 = 2] = "Secp256r1", s[s.Eip191 = 3] = "Eip191", s[s.Webauthn = 4] = "Webauthn", s))(h || {});
const Y = (s, t) => {
  const e = {
    Starknet: void 0,
    Secp256k1: void 0,
    Secp256r1: void 0,
    Eip191: void 0,
    Webauthn: void 0
  };
  if (s === h.Starknet)
    e.Starknet = t;
  else if (s === h.Secp256k1)
    e.Secp256k1 = t;
  else if (s === h.Secp256r1)
    e.Secp256r1 = t;
  else if (s === h.Eip191)
    e.Eip191 = t;
  else if (s === h.Webauthn)
    e.Webauthn = t;
  else
    throw new Error("Unknown SignerType");
  return new M(e);
}, D = E.encodeShortString("session-token");
class z extends N {
  constructor(t) {
    super(), this.signTransactionCallback = t;
  }
  async signRaw(t) {
    throw new Error("Method not implemented.");
  }
  async signTransaction(t, e) {
    return this.signTransactionCallback(t, e);
  }
}
class Q {
  constructor(t, e, o) {
    this.argentSessionService = t, this.chainId = e, this.dappKey = o;
  }
  getAccountWithSessionSigner(t, e, o, n, r = !1) {
    const a = new z(
      (i, c) => this.signTransaction(
        n,
        o,
        i,
        c,
        r
      )
    );
    return new I(t, e, a);
  }
  async signTransaction(t, e, o, n, r) {
    const a = O.getExecuteCalldata(
      o,
      n.cairoVersion
    );
    let i;
    if (Object.values(x.ETransactionVersion2).includes(
      n.version
    )) {
      const c = n;
      i = S.calculateInvokeTransactionHash({
        ...c,
        senderAddress: c.walletAddress,
        compiledCalldata: a,
        version: c.version
      });
    } else if (Object.values(x.ETransactionVersion3).includes(
      n.version
    )) {
      const c = n;
      i = S.calculateInvokeTransactionHash({
        ...c,
        senderAddress: c.walletAddress,
        compiledCalldata: a,
        version: c.version,
        nonceDataAvailabilityMode: f.intDAM(
          c.nonceDataAvailabilityMode
        ),
        feeDataAvailabilityMode: f.intDAM(
          c.feeDataAvailabilityMode
        )
      });
    } else
      throw Error("unsupported signTransaction version");
    return this.getSessionSignatureForTransaction(
      t,
      e,
      i,
      o,
      n.walletAddress,
      n,
      r
    );
  }
  async getSessionSignatureForTransaction(t, e, o, n, r, a, i) {
    const c = this.compileSessionHelper(e), p = A(e, this.chainId), l = await this.signTxAndSession(
      o,
      r,
      p,
      i
    ), u = await this.argentSessionService.signTxAndSession(
      n,
      a,
      p,
      l,
      i
    ), g = await this.compileSessionTokenHelper(
      c,
      e,
      n,
      l,
      t,
      u,
      i
    );
    return [D, ..._.compile(g)];
  }
  async signTxAndSession(t, e, o, n) {
    const r = m.getMessageHash(
      o,
      e
    ), a = S.computePoseidonHashOnElements([
      t,
      r,
      +n
    ]), i = k.starkCurve.sign(
      a,
      this.dappKey.privateKey
    );
    return [i.r, i.s];
  }
  buildMerkleTree(t) {
    const e = t.allowed_methods.map(
      (o) => S.computePoseidonHashOnElements([
        X,
        o["Contract Address"],
        B.getSelectorFromName(o.selector)
      ])
    );
    return new j.MerkleTree(e, S.computePoseidonHash);
  }
  getSessionProofs(t, e) {
    const o = this.buildMerkleTree(t);
    return e.map((n) => {
      const r = t.allowed_methods.findIndex(
        (a) => y.hexToDecimalString(a["Contract Address"]) === y.hexToDecimalString(n.contractAddress) && a.selector == n.entrypoint
      );
      return o.getProof(o.leaves[r], o.leaves);
    });
  }
  compileSessionHelper(t) {
    const e = K.byteArrayFromString(
      t.metadata
    ), o = [
      e.data.length,
      ...e.data,
      e.pending_word,
      e.pending_word_len
    ], n = S.computePoseidonHashOnElements(o);
    return {
      expires_at: t.expires_at,
      allowed_methods_root: this.buildMerkleTree(t).root.toString(),
      metadata_hash: n,
      session_key_guid: t.session_key_guid
    };
  }
  async compileSessionTokenHelper(t, e, o, n, r, a, i) {
    return {
      session: t,
      cache_authorization: i,
      session_authorization: r,
      sessionSignature: this.getStarknetSignatureType(
        this.dappKey.publicKey,
        n
      ),
      guardianSignature: this.getStarknetSignatureType(
        a.publicKey,
        [a.r, a.s]
      ),
      proofs: this.getSessionProofs(e, o)
    };
  }
  // function needed as starknetSignatureType is already compiled
  getStarknetSignatureType(t, e) {
    return Y(h.Starknet, {
      pubkey: t,
      r: e[0],
      s: e[1]
    });
  }
  buildOutsideExecution(t, e, o, n, r) {
    const a = E.encodeShortString("ANY_CALLER"), i = F.addHexPrefix(
      L(k.starkCurve.utils.randomPrivateKey())
    ), c = Date.now(), p = Math.floor((c + 6e4 * 20) / 1e3), l = Math.floor((c - 6e4 * 10) / 1e3);
    return {
      caller: e || a,
      nonce: r || i,
      execute_after: o || l,
      execute_before: n || p,
      calls: t.map((u) => $(u))
    };
  }
  buildOutsideExecutionTypedData(t, e, o, n, r, a) {
    const i = this.buildOutsideExecution(
      e,
      o,
      n,
      r,
      a
    );
    return w(i, t);
  }
  async getOutsideExecutionCall(t, e, o, n, r, a, i, c, p) {
    const l = this.buildOutsideExecution(
      n,
      a,
      i,
      c,
      p
    ), u = w(
      l,
      this.chainId
    ), g = await this.getSessionSignatureForOutsideExecutionTypedData(
      e,
      t,
      n,
      r,
      u,
      o
    );
    return {
      contractAddress: r,
      entrypoint: "execute_from_outside_v2",
      calldata: _.compile({ ...l, signature: g })
    };
  }
  async getSessionSignatureForOutsideExecutionTypedData(t, e, o, n, r, a) {
    const i = this.compileSessionHelper(e), c = A(e, this.chainId), p = m.getMessageHash(
      r,
      n
    ), l = await this.signTxAndSession(
      p,
      n,
      c,
      a
    ), u = await this.argentSessionService.signSessionEFO(
      e,
      n,
      r,
      l,
      a,
      this.chainId
    ), g = await this.compileSessionTokenHelper(
      i,
      e,
      o,
      l,
      t,
      u,
      a
    );
    return [D, ..._.compile(g)];
  }
  async getOutsideExecutionTypedData(t, e, o, n, r, a, i, c, p) {
    const l = this.buildOutsideExecutionTypedData(
      this.chainId,
      n,
      a,
      i,
      c,
      p
    ), u = await this.getSessionSignatureForOutsideExecutionTypedData(
      e,
      t,
      n,
      r,
      l,
      o
    );
    return {
      outsideExecutionTypedData: l,
      signature: u
    };
  }
}
const H = {
  StarknetDomain: [
    { name: "name", type: "shortstring" },
    { name: "version", type: "shortstring" },
    { name: "chainId", type: "shortstring" },
    { name: "revision", type: "shortstring" }
  ],
  "Allowed Method": [
    { name: "Contract Address", type: "ContractAddress" },
    { name: "selector", type: "selector" }
  ],
  Session: [
    { name: "Expires At", type: "timestamp" },
    { name: "Allowed Methods", type: "merkletree", contains: "Allowed Method" },
    { name: "Metadata", type: "string" },
    { name: "Session Key", type: "felt" }
  ]
}, X = m.getTypeHash(
  H,
  "Allowed Method",
  m.TypedDataRevision.Active
), Z = (s) => ({
  name: "SessionAccount.session",
  version: E.encodeShortString("1"),
  chainId: s,
  revision: "1"
}), A = (s, t) => ({
  types: H,
  primaryType: "Session",
  domain: Z(t),
  message: {
    "Expires At": s.expires_at,
    "Allowed Methods": s.allowed_methods,
    Metadata: s.metadata,
    "Session Key": s.session_key_guid
  }
}), R = (s, t, e, o) => ({
  expires_at: Number(t),
  allowed_methods: s,
  metadata: JSON.stringify(e),
  session_key_guid: S.computePoseidonHash(
    E.encodeShortString("Starknet Signer"),
    o
  )
}), se = async ({
  useCacheAuthorisation: s,
  accountSessionSignature: t,
  sessionRequest: e,
  provider: o,
  chainId: n,
  address: r,
  dappKey: a,
  argentSessionServiceBaseUrl: i
}) => {
  const c = new V(
    a.publicKey,
    t,
    i
  );
  return new Q(
    c,
    n,
    a
  ).getAccountWithSessionSigner(
    o,
    r,
    e,
    t,
    s
  );
}, ne = async ({
  wallet: s,
  sessionParams: t,
  chainId: e
}) => {
  const {
    allowedMethods: o,
    expiry: n = BigInt(Date.now()) + 10000n,
    publicDappKey: r,
    metaData: a
  } = t;
  if (!r)
    throw new Error("publicDappKey is required");
  const i = R(
    o,
    n,
    a,
    r
  ), c = A(i, e);
  return await s.request({
    type: "wallet_signTypedData",
    params: c
  });
};
export {
  X as ALLOWED_METHOD_HASH,
  V as ArgentSessionService,
  Q as SessionDappService,
  se as buildSessionAccount,
  R as createSessionRequest,
  $ as getOutsideCall,
  te as getOutsideExecutionCall,
  w as getOutsideExecutionTypedData,
  Z as getSessionDomain,
  A as getSessionTypedData,
  ee as getTypedDataHash,
  ne as openSession,
  H as sessionTypes,
  J as typesRev1
};
